import React from 'react';

const MobileSectionHeader = ({ title, action, onAction, actionLabel }) => {
  return (
    <div className="flex items-center justify-between px-4 mb-3">
      <h2 className="font-display text-base font-bold text-gray-900 dark:text-white">
        {title}
      </h2>
      {action || (onAction && actionLabel) ? (
        action ? (
          action
        ) : (
          <button
            onClick={onAction}
            className="text-sm font-medium text-primary hover:text-primary-light transition-colors"
          >
            {actionLabel}
          </button>
        )
      ) : null}
    </div>
  );
};

export default MobileSectionHeader;
